'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
var _extends = require('../../extends-733dd656.js');
var objectWithoutProperties = require('../../objectWithoutProperties-c6d3675c.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
var taggedTemplateLiteral = require('../../taggedTemplateLiteral-f923b98d.js');
var styled = require('styled-components');
require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
require('../../xstyled-prop-types.es-4220f7f4.js');
require('../../unsupportedIterableToArray-f175acfa.js');
var styles_breakpoints = require('../../breakpoints-ee0a4ae5.js');
require('../../components/GlobalStyle/GlobalStyle.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');
require('../../components/NuDSProvider/NuDSProvider.js');
require('../../utils/isType/isType.js');
require('../../defineProperty-3cad0327.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
require('../../Icon-efcd1bee.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
var components_Typography_Typography = require('../../components/Typography/Typography.js');
var components_Link_Link = require('../../components/Link/Link.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

function _templateObject2() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    padding-left: ", "px;\n    padding-right: ", "px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    padding-left: ", "px;\n    padding-right: ", "px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var footerMargin = styled.css(["padding:", " ", "px;", " ", ""], function (_ref) {
  var compact = _ref.compact;
  return compact ? '40px' : '80px';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.margin.mobileSmall;
}, styles_breakpoints.tablet768(_templateObject(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.margin.tablet;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.margin.tablet;
}), styles_breakpoints.desktop1024(_templateObject2(), function (_ref5) {
  var theme = _ref5.theme;
  return theme.margin.desktop;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.margin.desktop;
}));
var sectionStyle = styled.css(["&:not(:last-child){border-bottom:1px solid ", ";}", ";"], styles_themeUtils.nuDSColor('black', 'light'), footerMargin);

function _templateObject2$1() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    grid-row-gap: 80px;\n  "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    grid-template-columns: 1fr 1fr;\n  "]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var NavigationWrapper = styled__default['default'].div.withConfig({
  displayName: "Navigation__NavigationWrapper",
  componentId: "mkzgnq-0"
})(["", ";display:grid;grid-template-columns:1fr;grid-row-gap:48px;", " ", ""], sectionStyle, styles_breakpoints.tablet768(_templateObject$1()), styles_breakpoints.desktop1440(_templateObject2$1()));
NavigationWrapper.displayName = 'NavigationWrapper';

function _templateObject$2() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    margin-bottom: 0;\n  "]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var Column = styled__default['default'].div.withConfig({
  displayName: "Column",
  componentId: "ex5y51-0"
})(["align-items:flex-start;display:flex;flex-direction:column;&:last-of-type{margin-bottom:0;}", ""], styles_breakpoints.tablet768(_templateObject$2()));
Column.displayName = 'Column';

function ColumnTitle(props) {
  return /*#__PURE__*/React__default['default'].createElement(components_Typography_Typography['default'], _extends._extends_1({
    color: "white.dark",
    gutterBottom: 2,
    variant: "paragraph1"
  }, props));
}

function ColumnText(props) {
  return /*#__PURE__*/React__default['default'].createElement(components_Typography_Typography['default'], _extends._extends_1({
    color: "white.dark",
    variant: "text1"
  }, props));
}

var ColumnLink = styled__default['default'](components_Link_Link['default']).withConfig({
  displayName: "ColumnLink",
  componentId: "dwa2xt-0"
})(["margin-bottom:0.5rem;color:", ";&:hover{text-decoration:none;background:none;color:", ";}&:focus{text-decoration:none;background:none;}"], styles_themeUtils.nuDSColor('white'), styles_themeUtils.nuDSColor('primary', 'light'));
ColumnLink.defaultProps = {
  typographyProps: {
    variant: 'action'
  }
};
ColumnLink.displayName = 'ColumnLink';

function Navigation(_ref) {
  var children = _ref.children,
      className = _ref.className,
      others = objectWithoutProperties.objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/React__default['default'].createElement(NavigationWrapper, _extends._extends_1({
    className: className
  }, others), children({
    Column: Column,
    ColumnTitle: ColumnTitle,
    ColumnText: ColumnText,
    ColumnLink: ColumnLink
  }));
}

Navigation.defaultProps = {
  className: undefined
};
Navigation.propTypes = {
  children: index.propTypes.func.isRequired,
  className: index.propTypes.string
};

function _templateObject2$2() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    grid-template-columns: 98px 9fr 2fr;\n  "]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    margin-top: 0;\n  "]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var CompanyInfoContainer = styled__default['default'].div.withConfig({
  displayName: "CompanyWrappers__CompanyInfoContainer",
  componentId: "sc-1s6e3dt-0"
})(["", ""], styles_breakpoints.desktop1024(_templateObject$3()));
CompanyInfoContainer.displayName = 'CompanyInfoContainer';
var CompanyContainer = styled__default['default'].div.withConfig({
  displayName: "CompanyWrappers__CompanyContainer",
  componentId: "sc-1s6e3dt-1"
})(["", ";display:grid;grid-row-gap:40px;", ""], sectionStyle, styles_breakpoints.desktop1024(_templateObject2$2()));
CompanyContainer.displayName = 'CompanyContainer';

function _templateObject$4() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 0;\n  "]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var Social = styled__default['default'].div.withConfig({
  displayName: "Social",
  componentId: "dxbrx9-0"
})(["", ""], styles_breakpoints.desktop1024(_templateObject$4()));
Social.displayName = 'Social';

function CompanyInfo(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default['default'].createElement(CompanyInfoContainer, null, /*#__PURE__*/React__default['default'].createElement(components_Typography_Typography['default'], {
    color: "white.dark",
    variant: "text1"
  }, children));
}

CompanyInfo.propTypes = {
  children: index.propTypes.node
};
CompanyInfo.defaultProps = {
  children: null
};

function Company(_ref) {
  var children = _ref.children,
      className = _ref.className,
      others = objectWithoutProperties.objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/React__default['default'].createElement(CompanyContainer, _extends._extends_1({
    className: className
  }, others), children({
    CompanyInfo: CompanyInfo,
    Social: Social
  }));
}

Company.defaultProps = {
  className: undefined
};
Company.propTypes = {
  children: index.propTypes.func.isRequired,
  className: index.propTypes.string
};

var FooterWrapper = styled__default['default'].footer.withConfig({
  displayName: "FooterWrappers__FooterWrapper",
  componentId: "gokipc-0"
})(["background-color:", ";"], styles_themeUtils.nuDSColor('black'));
FooterWrapper.displayName = 'FooterWrapper';
var Section = styled__default['default'].div.withConfig({
  displayName: "FooterWrappers__Section",
  componentId: "gokipc-1"
})(["", ";"], sectionStyle);
Section.displayName = 'Section';

function Footer(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React__default['default'].createElement(FooterWrapper, {
    className: className
  }, children);
}

Footer.Navigation = Navigation;
Footer.Company = Company;
Footer.Section = Section;
Footer.defaultProps = {
  className: undefined
};
Footer.propTypes = {
  children: index.propTypes.node.isRequired,
  className: index.propTypes.string
};

exports.default = Footer;
//# sourceMappingURL=Footer.js.map
